import React from "react";
import {
  t,
  HEADING1,
  POINT1,
  T1_I1,
  T1_I2,
  T1_I3,
  T1_I4,
  T1_I5,
  T1_I6,
  T1_I7,
  T1_I8,
  POINT2,
  T2_R1C1,
  T2_R1C2,
  T2_R2C1,
  T2_R2C2,
  T2_R3C1,
  T2_R3C2,
  T2_R4C1,
  T2_R4C2,
  POINT3,
  POINT3_LI1,
  POINT3_LI2,
  POINT3_LI3_1,
  POINT3_LI3_2,
  POINT3_LI3_3,
  POINT4,
  POIN43_LI1,
  POIN43_LI2,
  POIN43_LI3,
  POIN43_LI4,
} from "../../translations/AboutUs/Procurement";

function Procurement() {
  return (
    <div
      className="procurement"
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div className="a-large" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(HEADING1)}
      </div>
      <div className="a-normal" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(POINT1)}
      </div>
      <table>
        <thead>
          <tr>
            <th rowSpan={2}>S.No</th>
            <th rowSpan={2}>Material Group Divisions</th>
            <th colSpan={5}>Annual Purchase Value Rs. in Crores</th>
          </tr>
          <tr>
            <th>KSRTC</th>
            <th>BMTC</th>
            <th>NWKRTC</th>
            <th>NEKRTC</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>{t(T1_I1)}</td>
            <td>647.57</td>
            <td>344.43</td>
            <td>452.14</td>
            <td>283.98</td>
            <td>1728.12</td>
          </tr>
          <tr>
            <td>2</td>
            <td>{t(T1_I2)}</td>
            <td>24.06</td>
            <td>13.13</td>
            <td>17.50</td>
            <td>15.31</td>
            <td>70.00</td>
          </tr>
          <tr>
            <td>3</td>
            <td>{t(T1_I3)}</td>
            <td>30.17</td>
            <td>13.42</td>
            <td>19.06</td>
            <td>13.60</td>
            <td>76.25</td>
          </tr>
          <tr>
            <td>4</td>
            <td>{t(T1_I4)}</td>
            <td>10.98</td>
            <td>5.25</td>
            <td>8.41</td>
            <td>5.06</td>
            <td>29.70</td>
          </tr>
          <tr>
            <td>5</td>
            <td>{t(T1_I5)}</td>
            <td>54.60</td>
            <td>36.40</td>
            <td>19.50</td>
            <td>15.60</td>
            <td>126.10</td>
          </tr>
          <tr>
            <td>6</td>
            <td>{t(T1_I6)}</td>
            <td>18.33</td>
            <td>5.22</td>
            <td>13.80</td>
            <td>7.70</td>
            <td>45.06</td>
          </tr>
          <tr>
            <td>7</td>
            <td>{t(T1_I7)}</td>
            <td>7.80</td>
            <td>5.20</td>
            <td>3.90</td>
            <td>3.90</td>
            <td>20.80</td>
          </tr>
          <tr>
            <td style={{ fontWeight: 600 }} />
            <td style={{ fontWeight: 600 }}>{t(T1_I8)}</td>
            <td style={{ fontWeight: 600 }}>793.51</td>
            <td style={{ fontWeight: 600 }}>423.05</td>
            <td style={{ fontWeight: 600 }}>534.31</td>
            <td style={{ fontWeight: 600 }}>345.15</td>
            <td style={{ fontWeight: 600 }}>2096.02</td>
          </tr>
        </tbody>
      </table>
      <div className="a-normal" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(POINT2)}
      </div>
      <table border={1} cellPadding={5}>
        <tbody>
          <tr>
            <td>{t(T2_R1C1)}</td>
            <td>{t(T2_R1C2)}</td>
          </tr>
          <tr>
            <td>{t(T2_R2C1)}</td>
            <td>{t(T2_R2C2)}</td>
          </tr>
          <tr>
            <td>{t(T2_R3C1)}</td>
            <td>{t(T2_R3C2)}</td>
          </tr>
          <tr>
            <td>{t(T2_R4C1)}</td>
            <td>{t(T2_R4C2)}</td>
          </tr>
        </tbody>
      </table>
      <div className="a-normal" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(POINT3)}
      </div>
      <ul style={{ margin: 0, padding: 0, marginLeft: 50 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(POINT3_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(POINT3_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>
          {t(POINT3_LI3_1)}
          <a href="https://www.eproc.karnataka.gov.in">{t(POINT3_LI3_2)}</a>
          {t(POINT3_LI3_3)}.
        </li>
      </ul>
      <div className="a-normal" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(POINT4)}
      </div>
      <ul style={{ margin: 0, padding: 0, marginLeft: 50 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(POIN43_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(POIN43_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(POIN43_LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(POIN43_LI4)}</li>
      </ul>
      {/* ------------- */}
    </div>
  );
}

export default Procurement;
